// import React, { useState, useEffect, useRef } from "react";
// import { Link } from "react-router-dom";
// import { ChevronUp, PlusCircle, RotateCcw } from "feather-icons-react/build/IconComponents";
// import { useDispatch, useSelector } from "react-redux";
// import ImageWithBasePath from "../../core/img/imagewithbasebath";
// import Brand from "../../core/modals/inventory/brand";
// import withReactContent from "sweetalert2-react-content";
// import Swal from "sweetalert2";
// import { all_routes } from "../../Router/all_routes";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import Datatable from "../../core/pagination/datatable";
// import { setToogleHeader } from "../../core/redux/action";
// import { apiClient } from "../../services/apiClient";
// import { useToast } from "../../Toaster/ToastContext";

// const ProductList = () => {

//   const { showToast } = useToast();
//   const dataSource = useSelector((state) => state.product_list);
//   const dispatch = useDispatch();
//   const data = useSelector((state) => state.toggle_header);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filteredData, setFilteredData] = useState(dataSource);
//   const [isLoading, setIsLoading] = useState(false);
//   const [pagination, setPagination] = useState({
//     currentPage: 1,
//     pageSize: 20,
//     totalPages: 0,
//     totalCount: 0,
//   });
//   const isDeleting = useRef(false);
//   const hasFetched = useRef(false);
//   const operationResult = useRef(null);
//   const route = all_routes;
//   const [permissions, setPermissions] = useState({
//     create: false,
//     read: false,
//     update: false,
//     delete: false,
//   });

//   useEffect(() => {
//     const storedPermissions = localStorage.getItem("rolespermissions");
//     let parsedPermissions = [];
//     try {
//       const Permissions = JSON.parse(storedPermissions);
//       const getPermissions = JSON.parse(Permissions.permissions);
//       if (getPermissions.permissions) {
//         parsedPermissions = getPermissions.permissions;
//       } else {
//         parsedPermissions = getPermissions;
//       }

//       const inventoryPermissions = parsedPermissions.find(
//         (item) => item.title === "Inventory"
//       );

//       const productPermissions = inventoryPermissions?.childPage?.find(
//         (child) => child.title === "Products"
//       );
//       // console.log("search product", productPermissions)

//       if (productPermissions) {
//         setPermissions({
//           create: productPermissions.create || false,
//           read: productPermissions.read || false,
//           update: productPermissions.update || false,
//           delete: productPermissions.delete || false,
//         });
//       } else {
//         console.error("Product permissions not found in localStorage");
//         showToast(
//           "Product permissions not found.",
//           "error",
//           "Permissions Error"
//         );
//       }
//     } catch (error) {
//       console.error("Error parsing permissions from localStorage:", error);
//       showToast("Failed to load permissions.", "error", "Permissions Error");
//     }
//   }, []);

//   const fetchProducts = async (currentPage = 1, pageSize = 20) => {
//     if (isLoading || isDeleting.current) {
//       return;
//     }

//     setIsLoading(true);
//     try {
//       const pageIndex = currentPage - 1;
//       const response = await apiClient.post("/get-all-products", {
//         pageIndex,
//         pageSize,
//       });

//       if (!response?.data || !Array.isArray(response.data)) {
//         throw new Error("Invalid data from server");
//       }

//       const requiredFields = [
//         "id",
//         "name",
//         "sku",
//         "product_type",
//         "category_name",
//       ];
//       const formattedProducts = response.data
//         .map((product) => {
//           const missing = requiredFields.filter(
//             (field) => !Object.prototype.hasOwnProperty.call(product, field)
//           );
//           if (missing.length) return null;
//           let imageUrl = "https://odabill.com/assets/img/product/noimage.png";
//           if (product.image) {
//             try {
//               const images = Array.isArray(product.image)
//                 ? product.image
//                 : JSON.parse(product.image);
//               if (images.length) imageUrl = images[0];
//             } catch (err) {
//               console.error("Error parsing product image:", err);
//               showToast(
//                 "Invalid product image format.",
//                 "error",
//                 "Product Error"
//               );
//               return null;
//             }
//           }

//           let price = product.price;
//           let qty = product.quantity ?? 0;
//           if (
//             product.product_type === "variable" &&
//             Array.isArray(product.variants)
//           ) {
//             price = product.variants.map((v) => parseFloat(v.price));
//             qty = product.variants.map((v) => v.quantity ?? 0);
//           }

//           return {
//             product: product.name,
//             sku: product.sku,
//             category: product.category_name || "Unknown",
//             brand: product.branch_name || "Unknown",
//             price,
//             productType: product.product_type,
//             qty,
//             productImage: imageUrl,
//             id: product.id,
//           };
//         })
//         .filter(Boolean);

//       dispatch({ type: "Product_list", payload: formattedProducts });
//       setFilteredData(formattedProducts);

//       setPagination({
//         currentPage: response.currentPage,
//         pageSize: response.pageSize ?? pageSize,
//         totalPages: response.totalPages ?? 1,
//         totalCount: response.totalCount ?? 0,
//       });
//     } catch (err) {
//       showToast(
//         err.message || "Failed to fetch products.",
//         "error",
//         "Product Error"
//       );
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!hasFetched.current) {
//       fetchProducts(pagination.currentPage, pagination.pageSize);
//       hasFetched.current = true;
//     }
//   }, [pagination.currentPage, pagination.pageSize]);

//   useEffect(() => {
//     const filtered = dataSource.filter((product) =>
//       [product.product, product.sku, product.category].some((field) =>
//         field?.toLowerCase().includes(searchTerm.toLowerCase())
//       )
//     );
//     setFilteredData(filtered);
//     setPagination((prev) => ({
//       ...prev,
//       totalCount: filtered.length,
//       totalPages: Math.ceil(filtered.length / prev.pageSize),
//     }));
//   }, [searchTerm, dataSource]);

//   const handleDelete = async (productId) => {
//     const MySwal = withReactContent(Swal);
//     MySwal.fire({
//       title: "Are you sure?",
//       text: "You won't be able to revert this!",
//       showCancelButton: true,
//       confirmButtonColor: "#00ff00",
//       confirmButtonText: "Yes, delete it!",
//       cancelButtonColor: "#ff0000",
//       cancelButtonText: "Cancel",
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           setIsLoading(true);
//           isDeleting.current = true;
//           const response = await apiClient.delete(
//             `/delete-product/${productId}`
//           );
//           if (response?.success) {
//             showToast("Product deleted successfully.", "success", "Product");
//             MySwal.fire({
//               title: "Deleted!",
//               text: "Product deleted successfully.",
//               confirmButtonText: "OK",
//               customClass: { confirmButton: "btn btn-success" },
//             });

//             hasFetched.current = false;
//           } else {
//             throw new Error(
//               response.message || "Unexpected response from server."
//             );
//           }
//         } catch (error) {
//           console.error("Error deleting product:", error.message);
//           showToast(
//             error.message || "Failed to delete product.",
//             "error",
//             "Product Error"
//           );
//           MySwal.fire({
//             title: "Error!",
//             text: error.message || "Failed to delete product.",
//             confirmButtonText: "OK",
//             customClass: { confirmButton: "btn btn-danger" },
//           });
//         } finally {
//           setIsLoading(false);
//           isDeleting.current = false;
//           await fetchProducts(pagination.currentPage, pagination.pageSize);
//         }
//       }
//     });
//   };

//   const handleModalClose = () => {
//     if (operationResult.current?.success) {
//       hasFetched.current = false;
//       fetchProducts(pagination.currentPage, pagination.pageSize);
//     }
//     operationResult.current = null;
//   };

//   const handleOperationComplete = (result) => {
//     operationResult.current = result;
//   };

//   const columns = [
//     {
//       title: "Product",
//       dataIndex: "product",
//       render: (text, record) => (
//         <span className="productimgname">
//           <Link className="product-img stock-img">
//             <ImageWithBasePath
//               alt="Product"
//               src={
//                 record.productImage ||
//                 "https://odabill.com/assets/img/default-product.jpg"
//               }
//             />
//           </Link>
//           <span className="wrap-text">{text}</span>
//         </span>
//       ),
//       sorter: (a, b) => a.product.length - b.product.length,
//       width: 200,
//     },
//     {
//       title: "SKU",
//       dataIndex: "sku",
//       render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
//       sorter: (a, b) => a.sku.length - b.sku.length,
//       width: 200,
//     },
//     {
//       title: "Category",
//       dataIndex: "category",
//       render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
//       sorter: (a, b) => a.category.length - b.category.length,
//       width: 200,
//     },
//     {
//       title: "Branch",
//       dataIndex: "brand",
//       sorter: (a, b) => a.brand.length - b.brand.length,
//       render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
//       width: 200,
//     },
//     {
//       title: "Price",
//       dataIndex: "price",
//       render: (value) => (
//         <span className="wrap-text">
//           {Array.isArray(value) ? `PKR [${value.join(", ")}]` : `PKR ${value}`}
//         </span>
//       ),
//       sorter: (a, b) => {
//         const getPrice = (val) =>
//           Array.isArray(val) ? Math.min(...val) : parseFloat(val);
//         return getPrice(a.price) - getPrice(b.price);
//       },
//       width: 250,
//     },
//     {
//       title: "Product Type",
//       dataIndex: "productType",
//       sorter: (a, b) => a.productType.length - b.productType.length,
//       render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
//       width: 100,
//     },
//     {
//       title: "Qty",
//       dataIndex: "qty",
//       render: (value) => (
//         <span className="wrap-text">
//           {Array.isArray(value) ? `[${value.join(", ")}]` : value}
//         </span>
//       ),
//       sorter: (a, b) => {
//         const getQty = (val) =>
//           Array.isArray(val) ? val.reduce((acc, v) => acc + v, 0) : val;
//         return getQty(a.qty) - getQty(b.qty);
//       },
//       width: 150,
//     },
//   ];

//   if (permissions.read || permissions.delete) {
//     columns.push({
//       title: "Action",
//       dataIndex: "action",
//       key: "actions",
//       render: (_, record) => (
//         <div className="action-table-data">
//           <div className="edit-delete-action">
//             {permissions.read && (
//               <Link
//                 className="me-2 p-2"
//                 to={`${route.editproduct}/${record.id}`}
//               >
//                 <i className="feather-edit" data-feather="edit"></i>
//               </Link>
//             )}
//             {permissions.delete && (
//               <Link
//                 className="confirm-text p-2"
//                 to="#"
//                 onClick={() => handleDelete(record.id)}
//               >
//                 <i className="feather-trash-2" data-feather="trash-2"></i>
//               </Link>
//             )}
//           </div>
//         </div>
//       ),
//       width: 100,
//     });
//   }

//   const renderRefreshTooltip = (props) => (
//     <Tooltip id="refresh-tooltip" {...props}>
//       Refresh
//     </Tooltip>
//   );
//   const renderCollapseTooltip = (props) => (
//     <Tooltip id="collapse-tooltip" {...props}>
//       Collapse
//     </Tooltip>
//   );

//   return (
//     <div className="page-wrapper">
//       <div className="content">
//         <div className="page-header">
//           <div className="add-item d-flex">
//             <div className="page-title">
//               <h4>Product List</h4>
//               <h6>Manage your products</h6>
//             </div>
//           </div>
//           <ul className="table-top-head">
//             <li>
//               <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
//                 <Link
//                   data-bs-toggle="tooltip"
//                   data-bs-placement="top"
//                   onClick={() => {
//                     hasFetched.current = false;
//                     fetchProducts(pagination.currentPage, pagination.pageSize);
//                   }}
//                 >
//                   <RotateCcw />
//                 </Link>
//               </OverlayTrigger>
//             </li>
//             <li>
//               <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
//                 <Link
//                   data-bs-toggle="tooltip"
//                   data-bs-placement="top"
//                   id="collapse-header"
//                   className={data ? "active" : ""}
//                   onClick={() => dispatch(setToogleHeader(!data))}
//                 >
//                   <ChevronUp />
//                 </Link>
//               </OverlayTrigger>
//             </li>
//           </ul>
//           <div className="page-btn">
//             {permissions.create && (
//               <Link to={route.addproduct} className="btn btn-added">
//                 <PlusCircle className="me-2 iconsize" />
//                 Add New Product
//               </Link>
//             )}
//           </div>
//         </div>
//         <div className="card table-list-card">
//           <div className="card-body">
//             <div className="table-top">
//               <div className="search-set">
//                 <div className="search-input">
//                   <input
//                     type="text"
//                     placeholder="Search products by name, SKU and category"
//                     className="form-control form-control-sm formsearch"
//                     aria-label="Search products"
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                   />
//                   <Link to="#" className="btn btn-searchset">
//                     <i data-feather="search" className="feather-search" />
//                   </Link>
//                 </div>
//               </div>
//             </div>
//             <div className="table-responsive">
//               <Datatable
//                 columns={columns}
//                 dataSource={filteredData}
//                 rowSelection={null}
//                 // pagination={{
//                 //   current: pagination.currentPage,
//                 //   pageSize: pagination.pageSize,
//                 //   total: pagination.totalCount,
//                 //   onChange: async (page, pageSize) => {
//                 //     // Update state and trigger API call
//                 //     setPagination((prev) => ({
//                 //       ...prev,
//                 //       currentPage: page,
//                 //       pageSize: pageSize,
//                 //     }));
//                 //     await fetchProducts(page, pageSize);
//                 //   },
//                 //   showSizeChanger: true,
//                 // }}
//               />
//             </div>
//           </div>
//         </div>
//         <Brand
//           onOperationComplete={handleOperationComplete}
//           onClose={handleModalClose}
//         />
//       </div>
//     </div>
//   );
// };

// export default ProductList;

import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import {
  ChevronUp,
  PlusCircle,
  RotateCcw,
} from "feather-icons-react/build/IconComponents";
import { useDispatch, useSelector } from "react-redux";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import Brand from "../../core/modals/inventory/brand";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { all_routes } from "../../Router/all_routes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Datatable from "../../core/pagination/datatable";
import { setToogleHeader } from "../../core/redux/action";
import { apiClient } from "../../services/apiClient";
import { useToast } from "../../Toaster/ToastContext";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const ProductList = () => {
  const { showToast } = useToast();
  const dataSource = useSelector((state) => state.product_list);
  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState(dataSource);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 20,
    totalPages: 0,
    totalCount: 0,
  });
  const isDeleting = useRef(false);
  const hasFetched = useRef(false);
  const operationResult = useRef(null);
  const route = all_routes;
  const [permissions, setPermissions] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  });

  useEffect(() => {
    const storedPermissions = localStorage.getItem("rolespermissions");
    let parsedPermissions = [];
    try {
      const Permissions = JSON.parse(storedPermissions);
      const getPermissions = JSON.parse(Permissions.permissions);
      if (getPermissions.permissions) {
        parsedPermissions = getPermissions.permissions;
      } else {
        parsedPermissions = getPermissions;
      }

      const inventoryPermissions = parsedPermissions.find(
        (item) => item.title === "Inventory"
      );

      const productPermissions = inventoryPermissions?.childPage?.find(
        (child) => child.title === "Products"
      );
      // console.log("search product", productPermissions)

      if (productPermissions) {
        setPermissions({
          create: productPermissions.create || false,
          read: productPermissions.read || false,
          update: productPermissions.update || false,
          delete: productPermissions.delete || false,
        });
      } else {
        console.error("Product permissions not found in localStorage");
        showToast(
          "Product permissions not found.",
          "error",
          "Permissions Error"
        );
      }
    } catch (error) {
      console.error("Error parsing permissions from localStorage:", error);
      showToast("Failed to load permissions.", "error", "Permissions Error");
    }
  }, []);

  const fetchProducts = async (currentPage = 1, pageSize = 20) => {
    if (isLoading || isDeleting.current) {
      return;
    }

    setIsLoading(true);
    try {
      const pageIndex = currentPage - 1;
      const response = await apiClient.post("/get-all-products", {
        pageIndex,
        pageSize,
      });

      if (!response?.data || !Array.isArray(response.data)) {
        throw new Error("Invalid data from server");
      }

      const requiredFields = [
        "id",
        "name",
        "sku",
        "product_type",
        "category_name",
      ];
      const formattedProducts = response.data
        .map((product) => {
          const missing = requiredFields.filter(
            (field) => !Object.prototype.hasOwnProperty.call(product, field)
          );
          if (missing.length) return null;
          let imageUrl = "https://odabill.com/assets/img/product/noimage.png";
          if (product.image) {
            try {
              const images = Array.isArray(product.image)
                ? product.image
                : JSON.parse(product.image);
              if (images.length) imageUrl = images[0];
            } catch (err) {
              console.error("Error parsing product image:", err);
              showToast(
                "Invalid product image format.",
                "error",
                "Product Error"
              );
              return null;
            }
          }

          let price = product.price;
          let qty = product.quantity ?? 0;
          if (
            product.product_type === "variable" &&
            Array.isArray(product.variants)
          ) {
            price = product.variants.map((v) => parseFloat(v.price));
            qty = product.variants.map((v) => v.quantity ?? 0);
          }

          return {
            product: product.name,
            sku: product.sku,
            category: product.category_name || "Unknown",
            brand: product.branch_name || "Unknown",
            price,
            productType: product.product_type,
            qty,
            productImage: imageUrl,
            id: product.id,
          };
        })
        .filter(Boolean);

      dispatch({ type: "Product_list", payload: formattedProducts });
      setFilteredData(formattedProducts);

      setPagination({
        currentPage: response.currentPage ?? currentPage,
        pageSize: response.pageSize ?? pageSize,
        totalPages: response.totalPages ?? 1,
        totalCount: response.totalCount ?? 0,
      });
    } catch (err) {
      showToast(
        err.message || "Failed to fetch products.",
        "error",
        "Product Error"
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!hasFetched.current) {
      fetchProducts(pagination.currentPage, pagination.pageSize);
      hasFetched.current = true;
    }
  }, [pagination.currentPage, pagination.pageSize]);

  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      currentPage: 1,
    }));
    hasFetched.current = false;
  }, [searchTerm]);

  useEffect(() => {
    const filtered = dataSource.filter((product) =>
      [product.product, product.sku, product.category].some((field) =>
        field?.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
    setFilteredData(filtered);
  }, [searchTerm, dataSource]);

  const handleDelete = async (productId) => {
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setIsLoading(true);
          isDeleting.current = true;
          const response = await apiClient.delete(
            `/delete-product/${productId}`
          );
          if (response?.success) {
            showToast("Product deleted successfully.", "success", "Product");
            hasFetched.current = false;
          } else {
            throw new Error(
              response.message || "Unexpected response from server."
            );
          }
        } catch (error) {
          console.error("Error deleting product:", error.message);
          showToast(
            error.message || "Failed to delete product.",
            "error",
            "Product Error"
          );
          MySwal.fire({
            title: "Error!",
            text: error.message || "Failed to delete product.",
            confirmButtonText: "OK",
            customClass: { confirmButton: "btn btn-danger" },
          });
        } finally {
          setIsLoading(false);
          isDeleting.current = false;
          await fetchProducts(pagination.currentPage, pagination.pageSize);
        }
      }
    });
  };

  const handleModalClose = () => {
    if (operationResult.current?.success) {
      hasFetched.current = false;
      fetchProducts(pagination.currentPage, pagination.pageSize);
    }
    operationResult.current = null;
  };

  const handleOperationComplete = (result) => {
    operationResult.current = result;
  };

  const columns = [
    {
      title: "Product",
      dataIndex: "product",
      render: (text, record) => (
        <span className="productimgname">
          <Link className="product-img stock-img">
            <ImageWithBasePath
              alt="Product"
              src={
                record.productImage ||
                "https://odabill.com/assets/img/default-product.jpg"
              }
            />
          </Link>
          <span className="wrap-text">{text}</span>
        </span>
      ),
      sorter: (a, b) => a.product.length - b.product.length,
      width: 200,
    },
    {
      title: "SKU",
      dataIndex: "sku",
      render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
      sorter: (a, b) => a.sku.length - b.sku.length,
      width: 200,
    },
    {
      title: "Category",
      dataIndex: "category",
      render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
      sorter: (a, b) => a.category.length - b.category.length,
      width: 200,
    },
    {
      title: "Branch",
      dataIndex: "brand",
      sorter: (a, b) => a.brand.length - b.brand.length,
      render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
      width: 200,
    },
    {
      title: "Price",
      dataIndex: "price",
      render: (value) => (
        <span className="wrap-text">
          {Array.isArray(value) ? `PKR [${value.join(", ")}]` : `PKR ${value}`}
        </span>
      ),
      sorter: (a, b) => {
        const getPrice = (val) =>
          Array.isArray(val) ? Math.min(...val) : parseFloat(val);
        return getPrice(a.price) - getPrice(b.price);
      },
      width: 250,
    },
    {
      title: "Product Type",
      dataIndex: "productType",
      sorter: (a, b) => a.productType.length - b.productType.length,
      render: (text) => <span className="wrap-text">{text || "N/A"}</span>,
      width: 100,
    },
    {
      title: "Qty",
      dataIndex: "qty",
      render: (value) => (
        <span className="wrap-text">
          {Array.isArray(value) ? `[${value.join(", ")}]` : value}
        </span>
      ),
      sorter: (a, b) => {
        const getQty = (val) =>
          Array.isArray(val) ? val.reduce((acc, v) => acc + v, 0) : val;
        return getQty(a.qty) - getQty(b.qty);
      },
      width: 150,
    },
  ];

  if (permissions.read || permissions.delete) {
    columns.push({
      title: "Action",
      dataIndex: "action",
      key: "actions",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            {permissions.read && (
              <Link
                className="me-2 p-2"
                to={`${route.editproduct}/${record.id}`}
              >
                <i className="feather-edit" data-feather="edit"></i>
              </Link>
            )}
            {permissions.delete && (
              <Link
                className="confirm-text p-2"
                to="#"
                onClick={() => handleDelete(record.id)}
              >
                <i className="feather-trash-2" data-feather="trash-2"></i>
              </Link>
            )}
          </div>
        </div>
      ),
      width: 100,
    });
  }

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="collapse-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  // Custom pagination logic
  const { currentPage, pageSize, totalPages, totalCount } = pagination;
  const startItem = totalCount > 0 ? (currentPage - 1) * pageSize + 1 : 0;
  const endItem = Math.min(startItem + pageSize - 1, totalCount);

  const pagesToShow = [];
  if (totalPages > 0) {
    if (totalPages <= 2) {
      for (let i = 1; i <= totalPages; i++) {
        pagesToShow.push(i);
      }
    } else {
      let middle = [];
      if (currentPage === 1) {
        middle = [1, 2];
      } else if (currentPage === totalPages) {
        middle = [totalPages - 1, totalPages];
      } else {
        middle = [currentPage, currentPage + 1];
      }

      if (middle[0] > 1) {
        pagesToShow.push(1);
      }
      if (middle[0] > 2) {
        pagesToShow.push("...");
      }
      middle.forEach((p) => pagesToShow.push(p));
      if (middle[1] < totalPages - 1) {
        pagesToShow.push("...");
      }
      if (middle[1] < totalPages) {
        pagesToShow.push(totalPages);
      }
    }
  }

  const changePage = (page) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: page,
    }));
    hasFetched.current = false;
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Product List</h4>
              <h6>Manage your products</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  onClick={() => {
                    hasFetched.current = false;
                    fetchProducts(pagination.currentPage, pagination.pageSize);
                  }}
                >
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={() => dispatch(setToogleHeader(!data))}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          <div className="page-btn">
            {permissions.create && (
              <Link to={route.addproduct} className="btn btn-added">
                <PlusCircle className="me-2 iconsize" />
                Add New Product
              </Link>
            )}
          </div>
        </div>
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search products by name, SKU and category"
                    className="form-control form-control-sm formsearch"
                    aria-label="Search products"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  <Link to="#" className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="table-responsive">
              <Datatable
                columns={columns}
                dataSource={filteredData}
                rowSelection={null}
                pagination={false}
              />
            </div>
            {/* Custom Pagination */}
            {totalCount > 0 && (
              <div className="custom-pagination d-flex justify-content-between align-items-center mt-4 mb-4">
                <div className="pagination-left">
                  Showing {startItem} - {endItem} of {totalCount}
                </div>
                <div className="pagination-right d-flex align-items-center">
                  <button
                    className="btn btn-sm btn-outline-secondary me-2"
                    disabled={currentPage === 1}
                    onClick={() => changePage(currentPage - 1)}
                  >
                    <LeftOutlined size={12} />
                  </button>
                  {pagesToShow.map((page, index) => (
                    <span key={index} className="me-2">
                      {page === "..." ? (
                        <span className="pagination-ellipsis">...</span>
                      ) : (
                        <button
                          className={`btn btn-sm ${
                            page === currentPage
                              ? "btn-primary"
                              : "btn-outline-secondary"
                          }`}
                          onClick={() => changePage(page)}
                        >
                          {page}
                        </button>
                      )}
                    </span>
                  ))}
                  <button
                    className="btn btn-sm btn-outline-secondary ms-2"
                    disabled={currentPage === totalPages}
                    onClick={() => changePage(currentPage + 1)}
                  >
                    <RightOutlined size={12} />
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        <Brand
          onOperationComplete={handleOperationComplete}
          onClose={handleModalClose}
        />
      </div>
    </div>
  );
};

export default ProductList;
